import { adminRoutes } from "./admin";
import { frontRoutes } from "./front";
import { PageRouteProps } from "./types";

export const routes: PageRouteProps[] = [...frontRoutes, ...adminRoutes];
